import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import {Col, FormGroup, Input, Label, Row} from 'reactstrap';
import _ from 'lodash';
import PropTypes from 'prop-types';
import {Validacao} from "../../../comum/components/Validacao";
import {formatTelefone} from "../../../../utils/formatar";
import NumberFormat from "react-number-format";
import Select from "react-select"

@inject("store")
@observer
export class DetalhamentoDebito extends Component {

    static propTypes = {
        isSolicitacaoProrrogacao: PropTypes.bool
    };

    constructor(props) {
        super(props);
    }

    render() {
        const solicitacao = this.props.controller.solicitacao;
        const descricaoCCDebito = this.props.controller.exibirDescricaoSolicitacaoCentroCustoDebito;
        return (
            <div>
                <h4>Débito</h4>
                <Row>
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>Centro de custo débito </Label>
                            <Input type="text" value={descricaoCCDebito} readOnly />
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label >Gestor centro de custo débito</Label>
                            <Input type="text" value={_.get(solicitacao, "gestorAreaDebito.nome")} readOnly  />
                        </FormGroup>
                    </Col>
                </Row>
            </div>
        )
    }
}